<!--
 * @Author: your name
 * @Date: 2022-01-11 18:03:44
 * @LastEditTime: 2022-03-01 16:23:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \scp-web\src\views\screenWalls\components\ScreenPanel.vue
-->
<template>
  <div
    :class="['screen-side-panel', position, { expand: !isExpand }]"
    :style="{ width: width + 'px' }"
  >
    <div class="screen-side-panel__body">
      <!-- <div :class="['screen-side-panel__arrow']"> -->
      <slot></slot>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: "left",
    },
    width: {
      type: Number,
      default: 508,
    },
    height: {
      type: Number,
      default: 422,
    },
    isExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
// .screen-side-panel {
//   position: relative;
//   background: linear-gradient(
//     270deg,
//     rgba(13, 15, 22, 0.76) 0%,
//     rgba(13, 15, 22, 0.456) 77%,
//     rgba(13, 15, 22, 0) 100%
//   );
//   border-radius: 0px 0px 0px 0px;
//   opacity: 1;
//   z-index: 2;
// }
.screen-side-panel {
  overflow: auto;
  // width: 479px;
  //   position: relative;

  position: absolute;
  top: 0px;
  //   height: calc(100% - 110px);
  // height:422px;
  //   margin-top: 105px;
  //margin-bottom: 15px;
  // background-color: rgba(#03133c, 0.9);
  // background-image: url("../assets/img/screenSideBg.png");
  // background-image: url("../assets/img/screenBoxbg.png");
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;

  transition: transform 550ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  z-index: 5;
  display: flex;
  flex-direction: column;
  height: calc(100% - 0px);

  &.full {
    height: calc(100% - 103px);
    top: 103px;
  }

  &.back {
    background-color: rgba(#03133c, 0.7);
  }

  &.default {
    right: 0;
  }

  &.left {
    left: 0px;
    background: linear-gradient(
      -270deg,
      rgba(13, 15, 22, 0.8) 0%,
      rgba(13, 15, 22, 0.5) 76%,

      rgba(13, 15, 22, 0) 100%
    );
    &.expand {
      transform: translateX(-100%);
      left: 0;
    }
  }

  &.right {
    right: 0px;
    background: linear-gradient(
      270deg,
      rgba(13, 15, 22, 0.8) 0%,
      rgba(13, 15, 22, 0.5) 76%,

      rgba(13, 15, 22, 0) 100%
    );
    &.expand {
      transform: translateX(100%);
      right: 0;
    }
  }

  &__content {
    padding: 20px 40px;
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
  }

  &__body {
    // padding: 20px;
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
  }

  &__arrow {
    position: absolute;
    top: 50%;
    z-index: 1;
    // background-color: rgba(#161d31, 0.8);
    padding: 10px 5px;
    transform: translateY(-50%);
    cursor: pointer;

    i {
      color: var(--primary-color);
    }

    &.left {
      right: -25px;
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
    }

    &.right {
      left: -25px;
      border-bottom-left-radius: 6px;
      border-top-left-radius: 6px;
    }
  }

  &__header {
    padding: 12px 20px;
    background-color: #1d253a;
    border-top-left-radius: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    i {
      cursor: pointer;
    }
  }

  &.show {
    transform: translateX(0);
  }
}
</style>
